import {
  AlertCircle,
  Bell,
  BookOpen,
  Building2,
  CalendarDays,
  ClipboardList,
  Clock,
  CreditCard,
  Crown,
  Ribbon,
  FileText,
  Globe,
  Images,
  LayoutDashboard,
  Layers,
  Link2,
  MessageSquare,
  Percent,
  ReceiptText,
  Settings,
  Sparkles,
  Upload,
  UserRound,
  UserX,
  Users,
} from 'lucide-react'

export const adminRouteEntries = [
  {
    key: 'dashboard',
    path: '/dashboard',
    group: 'Core',
    label: 'Dashboard',
    title: 'Dashboard',
    description: 'A live snapshot of your school with shortcuts to the most common admin tasks.',
    icon: LayoutDashboard,
    showInSidebar: true,
  },
  {
    key: 'users',
    path: '/users',
    group: 'Core',
    label: 'Users',
    title: 'Users',
    description: 'Manage every admin, teacher, student, and parent account from one place.',
    icon: Users,
    showInSidebar: true,
  },
  {
    key: 'classes',
    path: '/classes',
    group: 'Core',
    label: 'Classes',
    title: 'Classes',
    description: 'Organize classes, sections, and teacher allocations.',
    icon: Building2,
    showInSidebar: true,
  },
  {
    key: 'feeManagement',
    path: '/fee-management',
    aliases: ['/fees/analytics'],
    group: 'Core',
    label: 'Fee Management',
    title: 'Fee Management',
    description: 'Track fee demand, collections, overdue accounts, and adjustment impact.',
    icon: Sparkles,
    showInSidebar: true,
  },
  {
    key: 'examSessions',
    path: '/exam-sessions',
    group: 'Academic Ops',
    label: 'Exam Sessions',
    title: 'Exam Sessions',
    description: 'Group exams into terms and academic sessions.',
    icon: Layers,
    showInSidebar: true,
  },
  {
    key: 'exams',
    path: '/exams',
    group: 'Academic Ops',
    label: 'Exam Results',
    title: 'Exams',
    description: 'Create exams, manage result sheets, and publish marks.',
    icon: ClipboardList,
    showInSidebar: true,
  },
  {
    key: 'subjects',
    path: '/subjects',
    group: 'Academic Ops',
    label: 'Subjects',
    title: 'Subjects',
    description: 'Configure subjects used across timetable, exams, and reporting.',
    icon: BookOpen,
    showInSidebar: true,
  },
  {
    key: 'relations',
    path: '/parent-student-links',
    aliases: ['/relations'],
    group: 'Academic Ops',
    label: 'Parent-Student Links',
    title: 'Parent-Student Links',
    description: 'Link parents to students so notifications and fee visibility work correctly.',
    icon: Link2,
    showInSidebar: true,
  },
  {
    key: 'leaveRequests',
    path: '/leave-requests',
    aliases: ['/leaves'],
    group: 'Academic Ops',
    label: 'Leave Requests',
    title: 'Leave Requests',
    description: 'Review and manage leave requests across the school.',
    icon: FileText,
    showInSidebar: true,
  },
  {
    key: 'manageTimetable',
    path: '/manage-timetable',
    aliases: ['/timetable'],
    group: 'Academic Ops',
    label: 'Manage Timetable',
    title: 'Manage Timetable',
    description: 'Build and adjust the weekly class schedule.',
    icon: Clock,
    showInSidebar: true,
  },
  {
    key: 'calendar',
    path: '/calendar',
    group: 'Academic Ops',
    label: 'School Calendar',
    title: 'School Calendar',
    description: 'Plan school events, holidays, and key academic dates.',
    icon: CalendarDays,
    showInSidebar: true,
  },
  {
    key: 'gallery',
    path: '/gallery',
    group: 'Academic Ops',
    label: 'Events Gallery',
    title: 'Gallery',
    description: 'Create and manage school event albums and media.',
    icon: Images,
    showInSidebar: true,
  },
  {
    key: 'feeStructures',
    path: '/fee-structures',
    aliases: ['/fees/structures'],
    group: 'Finance',
    label: 'Fee Structures',
    title: 'Fee Structures',
    description: 'Design fee structures and academic-year billing templates.',
    icon: ReceiptText,
    showInSidebar: true,
  },
  {
    key: 'feeCollection',
    path: '/fee-collection',
    aliases: ['/fees/collection'],
    group: 'Finance',
    label: 'Fee Collection',
    title: 'Fee Collection',
    description: 'Record offline payments and update outstanding balances.',
    icon: CreditCard,
    showInSidebar: true,
  },
  {
    key: 'feeAccounts',
    path: '/fee-accounts',
    aliases: ['/fees/accounts'],
    group: 'Finance',
    label: 'Fee Accounts',
    title: 'Fee Accounts',
    description: 'Review generated student fee accounts and installment status.',
    icon: CreditCard,
    showInSidebar: true,
  },
  {
    key: 'feeDefaulters',
    path: '/fee-defaulters',
    aliases: ['/fees/defaulters'],
    group: 'Finance',
    label: 'Fee Defaulters',
    title: 'Fee Defaulters',
    description: 'Focus on overdue accounts and follow up on pending dues.',
    icon: AlertCircle,
    showInSidebar: true,
  },
  {
    key: 'feeDiscounts',
    path: '/fee-discounts',
    aliases: ['/fees/discounts'],
    group: 'Finance',
    label: 'Fee Adjustments',
    title: 'Fee Adjustments',
    description: 'Apply discounts, concessions, or fines without changing billing workflows.',
    icon: Percent,
    showInSidebar: true,
  },
  {
    key: 'subscription',
    path: '/subscription',
    group: 'Finance',
    label: 'Subscription',
    title: 'Subscription',
    description: 'Manage plans, renewals, and billing health for the platform.',
    icon: Crown,
    showInSidebar: true,
  },
  {
    key: 'schoolSettings',
    path: '/school-settings',
    aliases: ['/settings'],
    group: 'Workspace',
    label: 'School Settings',
    title: 'School Settings',
    description: 'Manage landing content, school branding, report-card templates, admission format, and Razorpay in the same flow used by Edubridge RN admins.',
    icon: Settings,
    showInSidebar: true,
  },
  {
    key: 'landingPage',
    path: '/landing-page',
    aliases: ['/landing'],
    group: 'Workspace',
    label: 'Landing Page',
    title: 'Landing Page Editor',
    description: 'Edit school stats, principal details, gallery, toppers, and achievements for the public school landing page.',
    icon: Globe,
    showInSidebar: true,
  },
  {
    key: 'notifications',
    path: '/notifications',
    group: 'Workspace',
    label: 'Notifications',
    title: 'Notifications',
    description: 'Send announcements to staff, students, and parents.',
    icon: Bell,
    showInSidebar: true,
  },
  {
    key: 'messages',
    path: '/messages',
    group: 'Workspace',
    label: 'Messages',
    title: 'Messages',
    description: 'Talk directly with teachers through school message threads.',
    icon: MessageSquare,
    showInSidebar: true,
  },
  {
    key: 'bulkUpload',
    path: '/bulk-upload',
    group: 'Workspace',
    label: 'Bulk Upload',
    title: 'Bulk Upload',
    description: 'Import users and parent-student links in bulk using CSV files.',
    icon: Upload,
    showInSidebar: true,
  },
  {
    key: 'profile',
    path: '/profile',
    group: 'Workspace',
    label: 'My Profile',
    title: 'My Profile',
    description: 'Review your account details, role, and linked operational records.',
    icon: UserRound,
    showInSidebar: true,
  },
  {
    key: 'alumni',
    path: '/alumni',
    group: 'Academic Ops',
    label: 'Alumni',
    title: 'Alumni',
    description: 'View students who completed the highest class — retained for history and report access.',
    icon: Ribbon,
    showInSidebar: true,
  },
  {
    key: 'inactiveUsers',
    path: '/inactive-users',
    group: 'Core',
    label: 'Inactive Users',
    title: 'Inactive Users',
    description: 'View and reactivate suspended accounts whose data is fully preserved.',
    icon: UserX,
    showInSidebar: true,
  },
  {
    key: 'students',
    path: '/students',
    group: 'Workspace',
    label: 'Students',
    title: 'Students',
    description: 'Review student records, enrolments, and class assignments.',
    icon: Users,
    showInSidebar: false,
  },
  {
    key: 'teachers',
    path: '/teachers',
    group: 'Workspace',
    label: 'Teachers',
    title: 'Teachers',
    description: 'Keep faculty details current and manage staff access.',
    icon: Users,
    showInSidebar: false,
  },
  {
    key: 'results',
    path: '/results',
    group: 'Academic Ops',
    label: 'Results',
    title: 'Results',
    description: 'Review recorded marks and student performance.',
    icon: ClipboardList,
    showInSidebar: false,
  },
  {
    key: 'reportCards',
    path: '/report-cards',
    group: 'Academic Ops',
    label: 'Report Cards',
    title: 'Report Cards',
    description: 'Access student report cards and marksheets by session.',
    icon: FileText,
    showInSidebar: false,
  },
  {
    key: 'reportCardDetail',
    title: 'Report Card Detail',
    description: 'Review session performance, exam breakdown, and published marksheet links for a student.',
    matcher: (pathname) => pathname.startsWith('/report-cards/'),
  },
  {
    key: 'marksheet',
    title: 'Marksheet',
    description: 'Inspect an exam marksheet and download the PDF copy.',
    matcher: (pathname) => pathname.startsWith('/marksheets/'),
  },
  {
    key: 'classDetail',
    title: 'Class Detail',
    description: 'View students, manage teachers, and promote students to the next academic year.',
    matcher: (pathname) => /^\/classes\/[^/]+$/.test(pathname),
  },
  {
    key: 'userProfile',
    title: 'User Profile',
    description: 'A full admin view of this account, including role details, linked records, and operational context.',
    matcher: (pathname) => pathname.startsWith('/users/'),
  },
  {
    key: 'teacherProfile',
    title: 'Teacher Profile',
    description: 'Review teaching profile details, assigned subjects, and timetable links.',
    matcher: (pathname) => pathname.startsWith('/teachers/'),
  },
  {
    key: 'examResultSheet',
    title: 'Result Sheet',
    description: 'Enter attendance, marks, feedback, and remarks for each student in this exam.',
    matcher: (pathname) => /^\/exams\/[^/]+\/result-sheet$/.test(pathname),
  },
  {
    key: 'feeAccountDetail',
    title: 'Fee Account Details',
    description: 'Inspect installments, receipts, and payment history for a student fee account.',
    matcher: (pathname) => pathname.startsWith('/fees/accounts/') || pathname.startsWith('/fee-accounts/'),
  },
  {
    key: 'feeReceipt',
    title: 'Fee Receipt',
    description: 'Print or download the official fee payment receipt.',
    matcher: (pathname) => pathname.startsWith('/fees/receipts/') || pathname.startsWith('/fee-receipts/'),
  },
]

const sidebarGroupOrder = ['Core', 'Academic Ops', 'Finance', 'Workspace']

export const sidebarAdminGroups = sidebarGroupOrder.map((label) => ({
  label,
  items: adminRouteEntries.filter((route) => route.showInSidebar && route.group === label),
}))

export const searchableAdminPages = adminRouteEntries
  .filter((route) => route.path && route.description)
  .map((route) => ({ ...route, to: route.path }))

const matchesExactRoute = (route, pathname) => route.path === pathname || route.aliases?.includes(pathname)

export const resolveAdminRoute = (pathname) => (
  adminRouteEntries.find((route) => matchesExactRoute(route, pathname))
  || adminRouteEntries.find((route) => route.matcher?.(pathname))
  || null
)
